





















import { defineComponent } from "@vue/composition-api";
import { MassMessageStat } from "@scrile/api-provider/dist/api/MassMessageStat";
import MassMessageStatItem from "../MassMessageStatItem";

export default defineComponent({
  name: "MassMessageStatView",
  components: { MassMessageStatItem },
  props: {
    items: { type: Array as () => MassMessageStat[], default: () => [] },
  },
});
